module.exports = Em.Component.extend({
    classNames: ['download-list'],

    items: null
})
